var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg06Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.1 12.2",
    style: {
      enableBackground: "new 0 0 16.1 12.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#788195;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,2.1c0.1,0,0.3,0,0.4,0c5.1,0,8.2,0,13.2,0c0.2,0,0.4,0,0.6,0c0.6-0.1,1-0.8,0.8-1.3 c-0.2-0.5-0.6-0.7-1.1-0.7c-2.6,0-5.2,0-7.9,0c0,0,0,0,0,0c-2.6,0-3.2,0-5.8,0c-0.1,0-0.3,0-0.4,0C0.4,0.2,0,0.6,0.1,1.1 C0.1,1.7,0.4,2.1,0.9,2.1z M15.2,5.1c-0.2,0-0.3,0-0.5,0C10.5,5,8.4,5,4.2,5c-1,0-2.1,0-3.1,0c-0.6,0-1.1,0.4-1.1,1 c0,0.6,0.4,1,1.1,1c0.1,0,0.2,0,0.2,0c1.9,0,2.7,0,4.1,0c0.5,0,1,0,1.6,0c2.5,0,5.1,0,7.6,0c0.2,0,0.3,0,0.5,0 C15.7,7,16,6.6,16,6.1C16.1,5.6,15.7,5.1,15.2,5.1z M10.6,10c-3.8,0-5.6,0-9.3,0c-0.1,0-0.3,0-0.4,0c-0.6,0.1-1,0.9-0.7,1.5 c0.2,0.4,0.6,0.6,1,0.6c1.2,0,1.6,0,2.2,0c0.4,0,0.8,0,1.5,0c1.9,0,3.9,0,5.8,0c0.7,0,1.2-0.6,1.1-1.3C11.6,10.3,11.2,10,10.6,10z  M15.1,10c-0.5,0-1,0.5-1,1c0,0.6,0.4,1,1,1c0.5,0,1-0.4,1-1C16.1,10.5,15.6,10,15.1,10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06Icon);
export default __webpack_public_path__ + "static/media/06-icon.a91534cbd19da7f79b74b6b253af1e2a.svg";
export { ForwardRef as ReactComponent };